<template>
    <div>
        <div class="index-body-box-outer">
            <div class="index-body-box">
            </div>
            <div class="lucency">
            </div>
            <div class="index-body-box-in">
                <div class="fade-in" style="color: #fff;font-size: 26px;margin-bottom: 10px;
    text-shadow: 0px 0px 5px #c8eef3;">{{ $t('common.CompanyName') }}</div>
                <div class=" fade-out-left">{{ $t('common.ScienceAndInnovationLife') }}</div>
                <div class=" fade-out-left">{{ $t('common.CommittedTo') }}</div>
                <div style="display: flex;color: #409eff;font-size: 22px;margin-top: 10px;">
                    <div style="margin-right: 20px;">
                        <div>{{ caseNumb }}{{ caseNumb == 1000 ? '+' : '' }}</div>
                        <div>{{ $t('common.theNumberOfUsers') }}</div>
                    </div>
                    <div>
                        <div>{{ serveNumb }}{{ serveNumb == 400 ? '+' : '' }}</div>
                        <div>{{ $t('common.serviceTeam') }}</div>
                    </div>
                </div>
                <div style="margin-top: 25px;">
                    <el-button type="primary" @click="gotoMacauBtn">{{ $t('common.SchedulingManagementSystem')
                        }}</el-button>
                    <el-popover style="margin-left:20px" placement="right" width="300" trigger="click">
                        <img src="../assets/contactUs.jpg" style="height: 300px;width: 300px" />
                        <el-button slot="reference" type="success">{{ $t('common.contactUs') }}</el-button>
                    </el-popover>
                </div>
            </div>
        </div>
        <img src="../assets/index2.jpg" style="width: 100%;box-sizing: border-box;padding:0 200px;height: auto;" alt="">
        <div class="index-body">
            <div v-show="show" class="index-container">
                <el-carousel class="fade-in" :height="computeHeight">
                    <el-carousel-item v-for="(item, index) in sliders" :key="index">
                        <img :src="item.img" class="slider_img">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div v-show="show1"
                style="display: flex;justify-content: space-between;align-items: center;margin-top: 40px;">
                <img src="../assets/content.jpg" style="width: 60%;"
                    class="container-img box-shadow-class-left fade-out-left" />
                <div>
                    <div style="display: flex;justify-content: center;">
                        <img src="../assets/灵感.gif" style="width: 100px;height: 100px;" alt="">
                    </div>
                    <h1 style="text-align: center;">{{ $t('common.MacaoContent4') }}</h1>
                </div>
            </div>
            <div v-show="show2"
                style="display: flex;justify-content: space-between;align-items: center;margin-top: 40px;">
                <img src="../assets/content2.jpg" class="container-img box-shadow-class-left fade-in" />
                <div>
                    <h1 style="text-align: center;">{{ $t('common.MacaoContent1') }}</h1>
                    <h1 style="text-align: center;">{{ $t('common.MacaoContent2') }}</h1>
                    <h1 style="text-align: center;">{{ $t('common.MacaoContent3') }}</h1>
                </div>
                <img src="../assets/content3.jpg" class="container-img box-shadow-class-right fade-in" />
            </div>
            <div v-show="show3" class="fade-out-bottom"
                style="justify-content: space-between;align-items: center;margin-top: 40px;">
                <h1 style="text-align: center;">{{ $t('common.MacaoContent5') }}
                    <img src="../assets/光照.gif" style="width: 100px;height: 100px;" alt="">
                </h1>
                <div style="padding: 10px;box-sizing: border-box;
            background-color: #409eff;border-radius: 20px;">
                    <img src="../assets/content1.jpg"
                        style="width:100%;height: auto;border: 3px solid #fff;box-sizing: border-box;"
                        class="container-img" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Index',
    data() {
        return {
            sliders: [],
            show: false,
            show1: false,
            show2: false,
            show3: false,
            caseNumb: 0,
            serveNumb: 0,
        }
    },
    methods: {
        gotoMacauBtn() {
            window.open('https://www.macau-power.com/hrui-0/login', '_blank');
        },
        dongHua(duration, temp) {
            var startTime = null;
            var animate = (timestamp) => {
                if (!startTime) {
                    startTime = timestamp;
                }
                var progress = timestamp - startTime;
                var step = Math.min(progress / duration, 1); // 计算动画进度，取值范围在 0 到 1 之间

                this[temp] = Math.floor(step * duration); // 根据进度更新动画状态

                if (progress < duration) {
                    requestAnimationFrame(animate); // 继续执行动画
                } else {
                    // 动画结束
                }
            };

            requestAnimationFrame(animate); // 启动动画
        },
        handleScroll() {
            // 获取页面滚动高度
            this.scrollHeight = window.scrollY || document.documentElement.scrollTop;
            if (this.scrollHeight > 400) {
                this.show = true
            }
            if (this.scrollHeight > 700) {
                this.show1 = true
            }
            if (this.scrollHeight > 1200) {
                this.show2 = true
            }
            if (this.scrollHeight > 1500) {
                this.show3 = true
                window.removeEventListener('scroll', this.handleScroll);
            }
        }
    },
    mounted() {
        this.sliders = [
            {
                img: require("../../static/slider/a1.jpg")
            },
            {
                img: require("../../static/slider/a2.jpg")
            },
            {
                img: require('../../static/slider/a3.jpg')
            },
            {
                img: require('../../static/slider/a4.jpg')
            }
        ]
        this.dongHua(1000, 'caseNumb')
        this.dongHua(400, 'serveNumb')
        // 监听页面高度
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    computed: {
        //计算高度
        computeHeight() {
            let screenHeight = document.body.clientWidth;
            if (screenHeight > 415) {
                return '550px';
            } else {
                return '250px';
            }
        }
    },
}
</script>

<style scoped>
.index-body-box-outer {

    position: relative;
}

.index-body-box {
    /* background-color: #c0ebf2; */
    background-image: url('~@/assets/content1.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 500px;
    padding: 30px 0 0 400px;
    box-sizing: border-box;
    opacity: 0.8;
}

.index-body-box-in {
    color: #2a2237;
    font-size: 30px;
    font-weight: bold;
    text-shadow: 0px 0px 5px #FFFFFF;
    position: absolute;
    top: 40px;
    left: 500px;
}

.box-shadow-class-right {
    box-shadow: 10px 10px 0px #409eff;
    border: 3px solid #fff;
    box-sizing: border-box;
}

.box-shadow-class-left {
    box-shadow: -10px 10px 0px #409eff;
    border: 3px solid #fff;
    box-sizing: border-box;
}

@keyframes fadeOutLeft {
    from {
        opacity: 0;
        transform: translateX(100%);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes fadeOutBottom {
    from {
        opacity: 0;
        transform: translateY(100%);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.fade-out-left {
    animation: fadeOutLeft 1s ease forwards;
}

.fade-out-bottom {
    animation: fadeOutBottom 1s ease forwards;
}

.index-body {
    /* background-image: url("../../static/slider/bodyBgc.jpg"); */
    background-repeat: no-repeat;
    background-size: contain;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 20px 200px;

    .container {
        padding: 50px 200px;
        box-sizing: border-box;
    }
}

.lucency {
    width: 100%;
    height: 200px;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff);
    position: absolute;
    bottom: 0;
    left: 0;
}

.container-img {
    border-radius: 20px;
    width: 40%;
    height: 300px;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.dongHua {
    animation: fadeIn 1s ease-in;
}

.fade-in {
    animation: fadeIn 1s ease-in;
    border-radius: 20px;
}

.border_parent {
    width: 90%;
    margin: auto;
}

.slider_img {
    height: 550px;
    width: 100%;
}

.solve {
    margin-top: 30px;
    margin-bottom: 10px
}

.border {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    height: auto;
    margin: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.border_one {
    margin-left: 0;
}

.border_img_parent {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.product_mobile_content {
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.product_mobile_img {
    width: 50%;
}

.product_mobile_title {
    font-weight: bold;
    text-align: center;
}

.product_pc_one {
    text-align: center;
    min-height: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.font_size_30 {
    font-size: 1.875em;
}

.product_font_style {
    font-size: 1.125em;
}

.product_pc_img {
    width: 100%
}

.product_pc_img_div {
    width: 50%;
    float: left;
    display: flex;
    align-items: center;
}

.product_pc {
    display: flex;
    width: 90%;
    margin: 20px auto;
    background: #F2F6FC;
    align-items: center;
}

.product_spec_title {
    margin-top: 30px;
    margin-bottom: 10px
}

.product_spec_parent {
    display: flex;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto
}

.cooperation_parent {
    display: flex;
    justify-content: center;
    width: 90%;
    margin: 20px auto;
    align-items: center;
    height: auto
}

.border_spec {
    border-radius: 6px;
    border: 1px solid #EBEEF5;
    float: left;
    width: 25%;
    height: auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.about_me_p {
    font-size: 1.25em;
    font-weight: normal;
    padding: 0 20px;
    margin: 10px;
}

.border_title {
    font-family: "PingFang SC";
    margin-top: 10px;
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
}

.border_content_one {
    margin-top: 20px;
    font-size: 1.125em;
    text-align: center;
}

.border_content_two {
    margin-top: 5px;
    font-size: 1.125em;
    margin-bottom: 25px;
    text-align: center;
}

.img_border {
    margin-top: 15px;
    width: 80px;
    height: 80px
}

.border_spec_inner_one {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 35px;
    height: 70px;
}

.border_spec_content_one {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    text-align: center;
}

.border_spec_inner_last {
    margin-top: 15px;
    font-size: 1.125em;
    float: left;
    margin-bottom: 25px;
    text-align: center;
}

.cooperation {
    margin-top: 30px;
    width: 100%;
}

.about_me {
    display: flex;
    margin-top: 30px;
    justify-content: center;
    width: 100%;
}

.product_mobile {
    width: 90%;
    align-items: center;
    margin: 20px auto;
    background: #F2F6FC;
}

.product_mobile_img_div {
    width: 50%;
    height: auto;
}

.product_mobile_content_one {
    margin-top: 20px;
    text-align: center;
}

.product_mobile_content_two {
    margin-top: 10px;
    text-align: center;
}

/* 屏幕设备适配 max-device-width: 400px */
@media screen and (max-device-width: 415px) {
    .slider_img {
        height: 250px;
        width: 100%;
    }


    .border_parent {
        display: flex;
        width: 90%;
        margin: auto;
        height: auto;
        flex-direction: column;
    }

    .border {
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        float: left;
        width: 100%;
        height: auto;
        margin: 10px 0 auto;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
            /*background: aquamarine;*/
    }

    .border_img_parent {
        margin-top: 0;

    }

    .product_mobile {
        width: 90%;
        align-items: center;
        margin: 20px auto;
        height: auto;
        background: #F2F6FC;
    }

    .product_mobile_content {
        width: 100%;
        margin-top: 15px;
    }

    .product_mobile_content_one {
        margin-top: 5px;
    }

    .product_mobile_content_two {
        margin-top: 5px;
    }

    .product_mobile_img_div {
        display: flex;
        width: 100%;
        height: auto;
        justify-content: center;
        margin-top: 10px;
        margin-bottom: 15px;
    }

    .product_mobile_img {
        float: left;
    }

    .product_mobile_title {
        font-weight: bold;
    }

    .product_pc_one {
        width: 100%;
        margin-top: 15px;
    }

    .font_size_30 {
        font-size: 1.25em;
    }

    .product_font_style {
        font-size: 1em;
    }

    .product_pc_img {
        height: 280px;
        width: 320px;
    }

    .product_pc_img_div {
        width: 100%;
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
    }

    .product_pc {
        display: flex;
        width: 90%;
        height: auto;
        margin: 20px auto;
        background: #F2F6FC;
        flex-direction: column;
    }

    .head-label {
        display: flex;
        margin-top: 10px;
    }

    .product_spec_parent {
        display: flex;
        width: 90%;
        align-items: center;
        justify-content: center;
        margin: 20px auto;
        height: auto;
        flex-direction: column;
    }

    .border_spec {
        float: left;
        height: auto;
        margin: 8px;
        width: 100%;
        border-radius: 6px;
        border: 1px solid #EBEEF5;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }


    .border_title {
        font-family: "PingFang SC";
        margin-top: 5px;
        font-size: 1.125em;
        font-weight: bold;
    }

    .border_content_one {
        margin-top: 5px;
        font-size: 1.125em;
    }

    .border_content_two {
        margin-top: 5px;
        font-size: 1.125em;
        margin-bottom: 8px;
    }

    .img_border {
        margin-top: 8px;
        width: 80px;
        height: 80px
    }

    .border_spec_inner_one {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 8px;
        /*background-color: aqua;*/
        height: 70px;
    }

    .border_spec_content_one {
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
    }

    .border_spec_inner_last {
        /*background-color: bisque;*/
        margin-top: 5px;
        font-size: 1.125em;
        float: left;
        margin-bottom: 8px;
    }

    .about_me {
        display: flex;
        margin-top: 10px;
        width: 100%;
    }
}

.border_spec_img {
    width: 75px;
    height: 55px;
    align-self: center
}

.font_size_24 {
    font-size: 1.5em;
}
</style>